class FlagSelect {
    constructor(c = {}) {
        this.parent = c.parent
        this.section = c.parent.closest('section.overflow-hidden');
        this.flag = this.parent.querySelector('.b-flag-select__flag')
        this.value = this.parent.querySelector('.b-flag-select__value')
        this.input = this.parent.querySelector('.b-flag-select__input')
        this.arrow = this.parent.querySelector('.b-flag-select__arrow')
        this.label = this.parent.querySelector('.b-flag-select__label')
        this.list = this.parent.querySelector('.b-flag-select__list')
        this.searchField = this.parent.querySelector('.b-flag-select__search-field')
        this.isCountryRedirect = this.parent.hasAttribute('country-redirect')
        this.selectedCountry = c.selectedCountry.code
        this.countries = c.countries
        this.optimusCountryList = c.optimusCountryList
        this.listCreated = false;
        this.item = null
        this.index = 0
        this.data = []
        this.countryList = c.countryList
        this.indexOfFlagSelect = c.indexOfFlagSelect;
        this.topEntriesLength = c.topEntriesLength;
        this.selectedCountryCodeValue = c.selectedCountry;
        this.value.innerText = c.selectedCountry.value || '';
        this.defaultCountryExistsInFirstList = true;
        this.initialCheckForCookie = true;
        this.maxLength = this.parent.getAttribute('data-flag-name-length') ? parseInt(this.parent.getAttribute('data-flag-name-length')) : 10
        this.isDropDownOpen = false;
        this.optionSelected;
        this.liselected;
        this.isFooterDropDown = c.isFooterDropDown;
        this.onPageLoadFlagSelect = true;
    }
    init() {
        this.listener()
        this.countryListAlreadyAdded = {};
        // this.select(this.input.getAttribute('data-initial-value'))
        this.searchField.style.maxWidth = this.value.offsetWidth + 'px'
        let countryListToIterate = this.countryList.slice(0, 20);
        const defaultCountryExists = countryListToIterate.find((country) => {
            return country.value === this.selectedCountryCodeValue.value
        });
        if (defaultCountryExists === undefined && this.selectedCountryCodeValue.value) {
            this.defaultCountryExistsInFirstList = false;
            countryListToIterate.push(this.selectedCountryCodeValue);
        }
        this.createList(true, countryListToIterate);
    }
    listener() {
        if (this.parent) {
            this.parent.addEventListener('click', e => {
                this.isDropDownOpen = e.target.classList && e.target.classList.contains('active');
                if (e.target.classList && e.target.classList.contains('b-flag-select')) {
                    this.isDropDownOpen ? this.close() : this.clickHandler()
                }
            })
        }
        if (this.flag) {
            this.flag.addEventListener('click', e => {
                this.clickHandler()
            })
        }
        if (this.value) {
            this.value.addEventListener('click', e => {
                this.clickHandler()
            })
        }
        if (this.arrow) {
            this.arrow.addEventListener('click', e => {
                this.clickHandler()
            })
        }
        if (this.label) {
            this.label.addEventListener('click', e => {
                this.clickHandler()
            })
        }
        window.addEventListener('click', e => {
            if (e.target.classList && e.target.classList.value && e.target.classList.value.indexOf('b-flag-select') === -1) {
                this.close()
            }
        })
        this.input.addEventListener('change', e => {
            this.close()
        })
        if (this.searchField) {
            this.searchField.addEventListener('input', e => {
                this.searchFilter(e.currentTarget.value)
            })
        }
    }
    searchFilter(val) {
        Array.prototype.slice.call(this.item).forEach(item => {
            let parsedText = item.innerText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            let parsedValue = val.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            if((!val) || (parsedText && val && parsedValue && (parsedText.toLowerCase().indexOf(parsedValue.toLowerCase()) !== -1 || item.innerText.toLowerCase().indexOf(val.toLowerCase()) !== -1))) {
                item.classList.remove('d-none')
                item.classList.add('d-flex')
            } else {
                item.classList.add('d-none')
                item.classList.remove('d-flex')
            }
        })
    }
    closeSearchFilter() {
        Array.prototype.slice.call(this.item).forEach(item => {
            item.classList.remove('d-none')
            item.classList.add('d-flex')
        })
    }
    clickHandler() {
        !this.listCreated && this.createList()
        this.parent.classList.toggle('active')
        this.toggleSearch()
        this.searchField.focus()
    }
    toggleSearch() {
        if (this.parent.classList.value && this.parent.classList.value.indexOf('active') === -1) {
            this.value.classList.remove('d-none')
            this.searchField.classList.add('d-none')
            this.section && this.section.classList.add('overflow-hidden');
        } else {
            this.value.classList.add('d-none')
            this.searchField.classList.remove('d-none')
            this.section && this.section.classList.remove('overflow-hidden');
        }
    }
    close() {
        for (let i = 0; i < document.querySelectorAll('.b-flag-select').length; i++) {
            document.querySelectorAll('.b-flag-select')[i].classList.remove('active')
        }
        this.toggleSearch()
    }

    removeLiSelected() {
        if (this.liselected && !this.defaultCountryExistsInFirstList) {
            this.liselected.remove();
            this.optionSelected.remove();
        }
    }

    setMultipleAttributes(el, attributesList) {
        for (let attributes in attributesList) {
            el.setAttribute(attributes, attributesList[attributes]);
        }
    }

    createList(onPageLoad, countryListToIterate = this.countryList) {
        // remove the liSelected i.e the default country selected
        this.removeLiSelected();
        // create document fragment 
        let fragment = document.createDocumentFragment();
        let index = 0
        // iterate on countryList [{code: 'in', value: 'india'}]
        for (var country of countryListToIterate) {
            let flag = country['code'];
            const flagLowerCase = flag.toLowerCase();
            let text = this.optimusCountryList && this.optimusCountryList[flagLowerCase] ? this.optimusCountryList[flagLowerCase] : country['value'].trim();
            if (flag && text && ((text === this.value.innerText && !this.defaultCountryExistsInFirstList) || !this.countryListAlreadyAdded[text])) {

                this.countryListAlreadyAdded[text] = true;

                let li = document.createElement('li');
                let liAttributeList = {
                    'role': 'option',
                    'id': `listboxFlagSelectList-${this.indexOfFlagSelect}-${index}`,
                    'data-flag-select-value': flag,
                    'data-flag-select-text': text
                }
                this.setMultipleAttributes(li, liAttributeList);
                li.className = 'wuds-dropdown__item b-flag-select__item p-0 cursor-pointer white-space-nowrap d-flex align-items-center pad-xs-horz';

                let divFlag = document.createElement('div');
                divFlag.className = 'wuds-dropdown__item__text bdr-clr-idel w-100';
                let iconTag = document.createElement('i');
                iconTag.className = `wu-flag ${flagLowerCase} flag__1x1 bdr-clr-idel bdr-thin-all bdr-radius-cir wu-flag__spacing-scale-md wu-input--icon__left  bkg-size-contain`;
                let divFlagText = document.createElement('span');
                divFlagText.className = 'b-flag-select__text w-100 overflow-hidden font-body-sm';
                divFlagText.setAttribute('title', text);
                divFlagText.innerText = text;
                divFlag.appendChild(divFlagText);
                divFlag.appendChild(iconTag);
                if (this.topEntriesLength - 1 === index) {
                    li.classList.add('position-static');
                    iconTag.classList.add('mar-xs-lt');
                }
                li.appendChild(divFlag);
                fragment.appendChild(li);

                let option = document.createElement('option')
                option.setAttribute('value', flag)
                option.innerText = text

                if (this.selectedCountry && (this.selectedCountry.toLowerCase() == flagLowerCase)) {
                    option.setAttribute('selected', true)
                    this.index = index;
                    this.value.innerText = text;
                    this.optionSelected = option;
                    this.liselected = li;
                }

                this.input.appendChild(option)
                this.data.push({
                    value: flag,
                    text: text
                })
                index++;
            } else if ((!onPageLoad && this.countryListAlreadyAdded[text])) {
                index++;
            }
        }
        this.list.appendChild(fragment);
        if (!onPageLoad) {
            this.listCreated = true
        }
        this.item = this.parent.querySelectorAll('.b-flag-select__item')
        this.listenerItemSelect()
        this.selectedCountry && this.start()
        const itemSelected = document.getElementById(`listboxFlagSelectList-${this.indexOfFlagSelect}-${this.index}`);
        this.selectedCountry && itemSelected && this.select(itemSelected)
    }
    listenerItemSelect() {
        Array.prototype.slice.call(this.item).forEach((item, index) => {
            if (item.getAttribute('eventListenerAdded') !== "true") {
                item.setAttribute('eventListenerAdded', true)
                item.addEventListener('click', e => {
                    this.index = index;
                    this.select(item)

                    this.searchField.value = ''
                    this.closeSearchFilter()

                    if (this.isCountryRedirect) {
                        const protocol = window.location.protocol
                        const port = window.location.port
                        let hostname = window.location.hostname
                        hostname = hostname === 'www.westernunion.ru' ? 'www.westernunion.com' : hostname
                        const redirectTo = `${protocol}//${hostname}${port && `:${port}`}/${this.input.value.toLowerCase()}/en/home.html`
                        window.location.href = redirectTo
                        return
                    }
                })
            }
        })
    }

    setInnerText(country) {
        if(WuAmerigoConfigs.isAmerigo()) {
            return this.countries.find((c) => c.country.isoCode === country)?.country?.name;
        } 
        return this.countryList.find(c => c.code === country)?.value
    }

    select(item) {
        let userSelectedValuesFromCookies = this.initialCheckForCookie ? this.checkCookieUserSelectedValue() : null;
        let receiverCountryFromParam = this.checkReceiverCountryInUrl();
        if (typeof item !== 'string') {
            this.input.value = item.getAttribute('data-flag-select-value')

            let text = item.getAttribute('data-flag-select-text')

            this.data.forEach(item => {
                this.flag.children[0].classList.remove(item.value.trim().toLowerCase())
            })
            if (this.onPageLoadFlagSelect && receiverCountryFromParam) {
                this.value.innerText = this.setInnerText(receiverCountryFromParam);
                this.flag.children[0].classList.add(receiverCountryFromParam.trim().toLowerCase());
                this.onPageLoadFlagSelect = false;
            } else if (userSelectedValuesFromCookies) {
                this.value.innerText = this.setInnerText(userSelectedValuesFromCookies.Country_Selected);
                this.flag.children[0].classList.add(userSelectedValuesFromCookies.Country_Selected.trim().toLowerCase());
            } else {
                this.value.innerText = text;
                this.flag.children[0].classList.add(item.getAttribute('data-flag-select-value').trim().toLowerCase());
            }
            this.input.dispatchEvent(new CustomEvent('change'))
            if (this.flag.children[0].classList.contains('d-none')) {
                this.flag.children[0].classList.remove('d-none');
                this.flag.children[1] && this.flag.children[1].classList.add('d-none');
            }
            this.toggleSearch()
        } else {
            this.value.innerText = item;
        }

    }
    start() {
        if (this.data && this.data[0]) {
            this.input.value = this.data[0].value
            this.value.innerText = this.data[0].text
            this.data.forEach(item => {
                let trimText = item.value.trim()
                this.flag.children[0].classList.remove(item.value.trim())
            })
            this.flag.children[0].classList.add(this.data[0].value.trim())
        }
    }

    checkCookieUserSelectedValue() {
        if (this.isFooterDropDown) {
            return;
        }
        const userSelectedValuesFromCookies = CookieService.getParsedCookieValue('userSelectedValues');
        this.initialCheckForCookie = false;
        return userSelectedValuesFromCookies;
    }
    getParamFromUrl() {
        let params = window.location.search || window.location.hash //"?FundsOut=BA&FundsIn=POLI";
        if (params === "") {
            params = null;
        }
        return params;
    }

    getURLParameter(name) {
        const urlParams = this.getParamFromUrl();
        let returnValue = urlParams && decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(urlParams) || [, ""])[1].replace(/\+/g, '%20')) || null
        if (returnValue) {
            returnValue = returnValue.trim();
        }
        return returnValue;
    }

    checkReceiverCountryInUrl() {
        const elem = `ReceiveCountry`
        let arrParamFiFo = this.getURLParameter(elem);
        return arrParamFiFo;
    }
}

const countryListEvent = new CustomEvent('countrylist');

function statFlag() {
    let flagSelectParentList = document.querySelectorAll('.b-flag-select:not(.country-language-dropdown)')
    if (flagSelectParentList.length > 0) {
        const requestPayload = {
            country: flagSelectParentList[0].getAttribute('data-country'),
            language: flagSelectParentList[0].getAttribute('data-language'),
            host: flagSelectParentList[0].getAttribute('data-host')
        }
        const senderCurrency = flagSelectParentList[0].getAttribute('data-currency');
        const senderCountry = flagSelectParentList[0].getAttribute('data-country');

        const getCountryListConfig = triggerCountryList(requestPayload);
        const headers = {
            'content-type': 'application/JSON'
        }
        httpRequest.get(`${getHttpRequestUrl()}content/wucom/base/global/config/activeVersion.json`)
            .then((versionInfo) => {
                httpRequest.post(`${getCountryListConfig.url}?dcaasversion=${versionInfo.dcaasVersion}`, getCountryListConfig.reqPayload, headers)
                    .then((response) => {
                        const calculatorEl = document.querySelector('.calculator');
                        triggerPriceCorridorList(
                            senderCountry,
                            senderCurrency ||
                            (calculatorEl && calculatorEl.getAttribute("data-currency")) ||
                            ISO_CODES_COUNTRIES_CURRENCIES[senderCountry.toUpperCase()]
                            ).initPriceCorridorApi().then((countriesList) => {
                                window.countryCurrencyDefaults = countriesList;
                                const priceCorridorReadyEvent = new CustomEvent("priceCorridorReady", {detail : {
                                    versionInfo,
                                    countriesList,
                                    dcaasResponse : response
                                }});
                                document.dispatchEvent(priceCorridorReadyEvent);
                                try {
                                    let userSelectedValuesFromCookies = CookieService.getParsedCookieValue('userSelectedValues');
                                    const isAmerigo = WuAmerigoConfigs.isAmerigo();
                                    for (let flagIndex = 0; flagIndex < flagSelectParentList.length; flagIndex++) {
                                        let selectedCountry = {};
                                        let countryListRefactored = [];
                                        const flagSelectDropdown = flagSelectParentList[flagIndex];
                                        const id = flagSelectDropdown.getAttribute('id');
                                        let dataSelected = flagSelectDropdown.getAttribute('data-selected');
                                        let displayFxRate = flagSelectDropdown.getAttribute('data-display-fx-rate');
                                        let initialDisplayFxRate = flagSelectDropdown.getAttribute('data-initial-display-fx-rate');
                                        const checkCurrencyConverter = /\/currency-converter\/.+\.html$/.test(window.location.pathname);
                                        const disableFX = sessionStorage.getItem('disableFXandFees');
                                        const disableInitialFXandFees = sessionStorage.getItem('disableInitialFXandFees');
                                        let evergageParam = {
                                            displayFxRate: disableFX !== "true",
                                            initialDisplayFxRate: ((disableInitialFXandFees && disableInitialFXandFees !== "true") || initialDisplayFxRate === '1')
                                        }
                                        if (!checkCurrencyConverter) {
                                            DisplayFxRateParamsService.setDisplayParams({
                                                displayFxRate: displayFxRate === '1',
                                                initialDisplayFxRate: initialDisplayFxRate === '1'
                                            }, ('disableFXandFees' in sessionStorage) ? evergageParam : undefined);
                                            displayFxRate = DisplayFxRateParamsService.getDisplayProp('displayFxRate');
                                        } else {
                                            DisplayFxRateParamsService.setDisplayParams({}, {});
                                        }
                                        sessionStorage.removeItem('disableFXandFees');
                                        sessionStorage.removeItem('disableInitialFXandFees');
                                        let topEntries = [];
                                        if (id === 'footer-country-dropdown') {
                                            ({ countryListRefactored, selectedCountry } = formatDropdownCountryList(response, selectedCountry, dataSelected, ['sender_country_list']));
                                            flagSelectService.initiateFlagSelect(countryListRefactored, flagSelectDropdown, flagIndex, topEntries, selectedCountry, true);
                                        } else if (id === 'gcr-country-dropdown') {
                                            ({ countryListRefactored, selectedCountry } = formatDropdownCountryList(response, selectedCountry, dataSelected, ['COUNTRY_LIST_GCR','COUNTRY_LIST']));
                                            flagSelectService.initiateFlagSelect(countryListRefactored, flagSelectDropdown, flagIndex, topEntries, selectedCountry, true);
                                        } else if (isAmerigo) {
                                            let countries = countriesList.countries;
                                            countries = flagSelectService.sortValues(countries);
                                            let countryList = {};
                                            countries.forEach(element => {
                                                countryList[element.country.isoCode] = element.country.name
                                            });
                                            dataSelected = userSelectedValuesFromCookies ? userSelectedValuesFromCookies['Country_Selected'] : dataSelected;
                                            const countriesConfigs = flagSelectService.getCountriesConfig(countriesList.countries, countryList, dataSelected,
                                                WuAmerigoConfigs.getTopCountries(), topEntries, response.COUNTRY_LIST);
                                            flagSelectService.initiateFlagSelect(countriesConfigs.countryListRefactored, flagSelectDropdown, flagIndex, countriesConfigs.topEntries, countriesConfigs.selectedCountry, false, countries, response.COUNTRY_LIST);
                                            document.dispatchEvent(countryListEvent);
                                        } else {
                                                window.countryCurrencyDefaults = countriesList;
                                                const countries = flagSelectService.sortValues(countryCurrencyDefaults.countries);
                                                dataSelected = userSelectedValuesFromCookies ? userSelectedValuesFromCookies['Country_Selected'] : dataSelected;
                                                const countriesConfigs = flagSelectService.getCountriesConfig(
                                                    countries, response.COUNTRY_LIST, dataSelected,
                                                    response.TOP_COUNTRIES, topEntries)
                                                flagSelectService.initiateFlagSelect(countriesConfigs.countryListRefactored, flagSelectDropdown, flagIndex, countriesConfigs.topEntries, countriesConfigs.selectedCountry);
                                                document.dispatchEvent(countryListEvent);
                                        }
                                    }
                                    if ((window.location.pathname.indexOf('currency-converter') !== -1)
                                        || document.querySelector('#currency-converter-main')
                                    ) {
                                        document.dispatchEvent(countryListEvent);
                                    }
                                } catch (e) {
                                    console.log(`Country list is empty fo ${requestPayload.country}-${requestPayload.language}`);
                                    console.error(e);
                                }
                            }, () => {
                                console.log('error in price corridor');
                            })
                    }, () => {
                        console.log('error');
                    })
            }, (e) => {
                console.log(`active version failed`)
            })
    }
}

function formatDropdownCountryList(response, selectedCountryObject, dataSelected, countrylistKeysArray) {
    let countryListRefactored = [];
    let countryList = response;
    let selectedCountry = selectedCountryObject;
    const dataSelectedLowerCase = dataSelected.toUpperCase();
    for (let level = 0; level < countrylistKeysArray.length; level++) {
        countryList = countryList[countrylistKeysArray[level]];
    }
    for (let code in countryList) {
        if (dataSelectedLowerCase === code.toUpperCase()) {
            selectedCountry.code = code;
            selectedCountry.value = countryList[code];
        }
        if (code.length === 2) {
            countryListRefactored.push({
                'value': countryList[code],
                'code': code
            });
        }
    }
    countryListRefactored = flagSelectService.sortValues(countryListRefactored, true);
    return {
        countryListRefactored,
        selectedCountry
    };
}